// CustomPhoneSelectDropdown.js
import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./CustomPhoneSelect.css";

export default function CustomPhoneSelect({ options, value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState(
    "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tr.svg"
  );

  const selectRef = useRef(null);

  const handleOptionClick = (val, flag) => {
    onChange(val[0]);
    setSelectedFlag(flag);
    setIsOpen(false);
  };

  const handleOutsideClick = (e) => {
    if (selectRef.current && !selectRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  return (
    <div className="phone-select-container" ref={selectRef}>
      <div
        className="phone-select-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={selectedFlag} alt="flag" className="flag-img" />
        <span className="phone-code">{value}</span>
        <FaChevronDown className="dropdown-arrow" />
      </div>

      {isOpen && (
        <div className="phone-options-container">
          {options.map((option, index) => (
            <div
              key={index}
              className="phone-option-item"
              onClick={() => handleOptionClick(option.dialCodes, option.image)}
            >
              <img src={option.image} alt={option.name} className="flag-img" />
              {option.dialCodes}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
